"use client"
import BreadCrumbsWrapper from "common/BreadCrumbs"
import { useIsDesktop } from "common/MediaQueries"
import { useState } from "react"
import AppoitmentIcon from "reusable/icons/hamesayat/AppoitmentIcon"
import CarIcon from "reusable/icons/hamesayat/CarIcon"
import FaultIcon from "reusable/icons/hamesayat/FaultIcon"
import LocationIcon from "reusable/icons/hamesayat/LocationIcon"
import RepairIcon from "reusable/icons/hamesayat/RepairIcon"
import TimeIcon from "reusable/icons/hamesayat/TimeIcon"
import TowingIcon from "reusable/icons/hamesayat/TowingIcon"
import WalletIcon from "reusable/icons/hamesayat/WalletIcon"
import ZoomInIcon from "reusable/icons/hamesayat/ZoomInIcon"
import PhoneIcon from "reusable/icons/HamesayatPhoneIcon"
import PopUp from "reusable/popups/PopUp"
import TowingModal from "reusable/popups/TowingModal"
import RepairModal from "reusable/popups/VehicleModal"
import { StyledBody, StyledBody2, StyledLink } from "reusable/wrappers/BodyText"
import { StyledHeaderH1 } from "reusable/wrappers/CenterText"
import IconTextBody from "reusable/wrappers/IconTextBody"
import ImageContainer from "reusable/wrappers/ImageContainer"
import styled from "styled-components"
import { StyledPageWrapper } from "theme/shared"

const serviceResponseData = [
  {
    icon: <TimeIcon />,
    text: "מענה טלפוני 24/7",
    subText: "לפניות בנושאים טכניים",
  },
  {
    icon: <AppoitmentIcon />,
    text: "סיוע בקביעת תור",
    subText: "למרכז שירות מורשה דלק מוטורס",
  },
  {
    icon: <PhoneIcon />,
    text: "ליווי טלפוני",
    subText: "עד כניסת הרכב למרכז השירות",
  },
  {
    icon: <FaultIcon />,
    text: "תקלה משביתה",
    subText: "סיוע וליווי בהפעלת גרר בהתאם לתנאי פוליסת הביטוח",
    margin: "true",
  },
  {
    icon: <ZoomInIcon />,
    text: "שירותים נוספים",
    subText: "שירות בתשלום עבור דלק / פריצת הרכב / החלפת גלגל",
    margin: "true",
  },
  {
    icon: <LocationIcon />,
    text: "מרכזי שירות",
    subText: "לרשימה ברחבי הארץ",
    link: "לרשימה מרכזי השירות לחצו כאן",
    margin: "true",
  },
]

const assistanceResponseData = [
  {
    icon: <TowingIcon />,
    text: "גרירה בחינם",
    subText: "שירותי גרירה",
    popUp: "מידע נוסף",
    type: "towing",
  },
  {
    icon: <CarIcon />,
    text: "תיקון מקצועי",
    subText: "תיקונים ע״י מקצוענים ברשת השירות של דלק מוטורס",
  },
  {
    icon: <RepairIcon />,
    text: "העמדת רכב חלופי",
    subText: "שירות ללא חיוב",
    popUp: "מידע נוסף",
    type: "repair",
  },
  {
    icon: <WalletIcon />,
    text: "השתתפות עצמית",
    subText: "בהתאם לתנאי ההסדר של חברות הביטוח",
    margin: "true",
  },
  {
    icon: <PhoneIcon />,
    text: "ליווי טלפוני",
    subText: "במהלך כל אירוע",
    margin: "true",
  },
  {
    icon: <LocationIcon />,
    text: "מרכזי שירות",
    subText: "לרשימה ברחבי הארץ",
    link: "לרשימה מרכזי השירות לחצו כאן",
    margin: "true",
  },
]

const StyledPageDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  display: flex;
  align-items: center;
  background: ${(p) => p.theme.colors.lightGrey};
  padding-bottom: 80px;
`

const StyledTextWrapp = styled.div`
  margin-top: 40px;
  max-width: 1400px;
  text-align: center;
  width: 100%;
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-right: 20px;
    padding-left: 20px;
    text-align: right;
  }
`

const StyledLine = styled.div`
  border: 0.5px solid ${(p) => p.theme.colors.darkGrey};
  margin-top: 70px;
`

const StyledFooter = styled.div`
  margin-top: 70px;
`
const StyledModalContainer = styled.div`
  width: 100%;
  text-align: right;
`

const HamesayatPage = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [modalType, setModalType] = useState("")
  const isDesktop = useIsDesktop()

  const handleModalClose = () => {
    setModalOpen(false)
  }

  return (
    <StyledPageWrapper $padding={"0"}>
      <StyledPageDiv>
        <ImageContainer
          src={isDesktop ? "/img/hamesayat.jpg" : "/img/hamesayatmobile.jpg"}
        />
        <BreadCrumbsWrapper name="Hamesayat" />
        <StyledTextWrapp>
          <StyledHeaderH1>המסייעת</StyledHeaderH1>
          <StyledBody $margin={20}>
            בעלי מאזדה נהנים מראש שקט בכל מצב עם מוקד שירות 24/7{" "}
            <StyledLink $color={"#4C607E"} href={"tel:*2880"}>
              {" "}
              חייגו 2880*{" "}
            </StyledLink>{" "}
          </StyledBody>
          {isDesktop && <StyledLine />}
          <IconTextBody data={serviceResponseData} title={"מענה שירותי"} />
          {isDesktop && <StyledLine />}
          <IconTextBody
            data={assistanceResponseData}
            title={"סיוע בעת תאונה"}
            setModalOpen={setModalOpen}
            setModalType={setModalType}
          />
          <StyledFooter>
            <StyledBody2>לפרטים נוספים פנה לאגף השירות</StyledBody2>
            <StyledLink $color="#4C607E" href={"tel:08-9139995"} $margin={10}>
              08-9139995
            </StyledLink>
            <StyledBody>
              השירות מיועד לרכבים בבעלות פרטית בלבד ובכפוף
              {isDesktop ? <br></br> : " "}
              לתקנון ״המסייעת״ המצוי במשרדי דלק מוטורס בע״מ
            </StyledBody>
          </StyledFooter>
        </StyledTextWrapp>
        <PopUp open={modalOpen} setOpen={handleModalClose}>
          <StyledModalContainer>
            {modalType === "repair" ? <RepairModal /> : <TowingModal />}
          </StyledModalContainer>
        </PopUp>
      </StyledPageDiv>
    </StyledPageWrapper>
  )
}

export default HamesayatPage
